<button
  matRipple
  (click)="clicked.emit()"
  class="hypecast-secondary-button group flex items-center rounded-md text-xl h-12"
>
  <ng-content />
</button>
